<div class="dropdown" [class.is-active]="isOpen" data-e2e="button-entity-dropdown">
  <div class="dropdown-trigger">
    <button
      [attr.aria-expanded]="isOpen"
      class="button is-chip is-size-7-mobile"
      [class.is-applied]="selectedEntities.size"
      [class.is-active]="isOpen"
      data-e2e="button-entity-filter"
      [attr.aria-expanded]="isOpen"
      (click)="itemToggled.emit()"
      type="button"
      title="{{ headerText }}"
    >
      <span data-e2e="button-entity-filter-text">{{ headerText }}</span>
      <span data-e2e="button-entity-filter-icon" class="icon">
        <i class="fas fa-chevron-down"></i>
      </span>
    </button>
  </div>
  <div class="dropdown-menu" name="date-drop-down">
    <div class="dropdown-content">
      <div class="has-border-bottom" [ngClass]="{ 'pt-3': !isSelectorsVisible && showQuickPicks }">
        <div *ngIf="isSelectorsVisible" class="label pl-3 mb-0">
          <span i18n>Date</span>
        </div>
        <div
          class="is-flex is-flex-wrap-wrap is-align-items-center has-border-bottom px-3 pb-2"
          *ngIf="isSelectorsVisible"
          data-e2e="date-filter-selectors"
        >
          <div *ngFor="let selector of selectors" class="mr-2">
            <portal-search-filter-radio
              [id]="selector.id"
              [text]="selector.label"
              [radioName]="radioName"
              [selectedEntities]="selectedRadioMap"
              [refresh$]="refreshRadioButton$"
              (selected)="onRadioSelected(selector)"
            ></portal-search-filter-radio>
          </div>
        </div>
        <div class="is-flex-grow-2">
          <portal-date-picker
            #datePicker
            [fromDate]="fromDate"
            [toDate]="toDate"
            [showQuickPicks]="showQuickPicks"
            [quickPicksList]="quickPicksList"
            (fromDateApplied)="onFromDateApplied($event)"
            (toDateApplied)="onToDateApplied($event)"
            (quickPickSelected)="onQuickPickSelect($event)"
          ></portal-date-picker>
        </div>
      </div>
      <div class="is-flex pb-0 pl-3 pt-3">
        <button
          class="button is-primary"
          data-e2e="button-filter"
          (click)="onFilterApplied()"
          [disabled]="!areInputsValid()"
          type="button"
          i18n
          title="Apply"
          i18n-title
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
